export const actionTypes = {
  GET_USER: 'GET_USER',
  GET_USER_SUCCESS: 'GET_USER_SUCCESS',
  LOGIN_USER: 'LOGIN_USER',
  LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
  SEND_EMAIL_FOR_PASSWORD_RESET: 'SEND_EMAIL_FOR_PASSWORD_RESET',
  RESET_PASSWORD: 'RESET_PASSWORD',
  LOGOUT: 'LOGOUT',
  GET_USER_WITH_CODE: 'GET_USER_WITH_CODE',
  GET_USER_WITH_CODE_SUCCESS: 'GET_USER_WITH_CODE_SUCCESS',
  GET_SIGN_IN_URL: 'GET_SIGN_IN_URL',
};

export const getUser = (callback = () => {}) => ({
  type: actionTypes.GET_USER,
  callback,
});

export const getUserSuccess = data => ({
  type: actionTypes.GET_USER_SUCCESS,
  payload: data,
});

export const login = (data, callback = (_res: boolean, _message: string) => {}) => ({
  type: actionTypes.LOGIN_USER,
  callback,
  payload: data,
});

export const loginSuccess = data => ({
  type: actionTypes.LOGIN_USER_SUCCESS,
  payload: data,
});

export const submitEmailForPasswordReset = (data, callback = (_res: boolean, _message: string) => {}) => ({
  type: actionTypes.SEND_EMAIL_FOR_PASSWORD_RESET,
  callback,
  payload: data,
});

export const resetPassword = (data, callback = (_res: boolean, _message: string) => {}) => ({
  type: actionTypes.RESET_PASSWORD,
  callback,
  payload: data,
});

export const logout = () => ({
  type: actionTypes.LOGOUT,
});

export const getUserWithCode = (code, callback = _res => {}) => ({
  type: actionTypes.GET_USER_WITH_CODE,
  callback,
  payload: code,
});

export const getUserWithCodeSuccess = data => ({
  type: actionTypes.GET_USER_WITH_CODE_SUCCESS,
  payload: data,
});

export const getSignInUrl = (data, callback = (_res: boolean, _message: string) => {}) => ({
  type: actionTypes.GET_SIGN_IN_URL,
  callback,
  payload: data,
});
